<tp-page-scaffold [pageAvailability]="availability$ | async">
  <div class="scroll-box" (scroll)="checkScrollLocation($event)">
    <div class="tp-bento-box subtle notif-bar">
      <h3>Settings for {{team.id}}</h3>
      <p>{{teamMemberCount$ | async}} team member{{(teamMemberCount$ | async) === 1 ? '' : 's'}}.</p>
      <p>Team created on {{team.createdAt | datetime}}</p>
    </div>

    <div class="drawer-container">
      <div class="drawer-content">
        <div class="drawer-section">
          <a [class.active]="this.activeSettingsSection === 'general'" routerLink="./general">General</a>
          <a [class.active]="currentActive === 'details'" routerLink="./general" fragment="details">Team details</a>
          <a [class.active]="currentActive === 'members'" routerLink="./general" fragment="members">Team members</a>
          <a [class.active]="currentActive === 'api-tokens'" routerLink="./general" fragment="api-tokens">API tokens</a>
          <a [class.active]="currentActive === 'danger-zone'" routerLink="./general" fragment="danger-zone">Danger zone</a>
        </div>
        <div class="drawer-section">
          <a [class.active]="this.activeSettingsSection === 'billing'" routerLink="./billing">Billing</a>
          <a [class.active]="currentActive === 'upcoming-bill'" routerLink="./billing" fragment="upcoming-bill">Upcoming bill</a>
          <a [class.active]="currentActive === 'invoices'" routerLink="./billing" fragment="invoices">Invoices</a>
          <a [class.active]="currentActive === 'card'" routerLink="./billing" fragment="card">Payment card</a>
          <a [class.active]="currentActive === 'marketplace'" routerLink="./billing" fragment="marketplace">Marketplace</a>
          <a [class.active]="currentActive === 'credits'" routerLink="./billing" fragment="credits">Credits</a>
          <a [class.active]="currentActive === 'discounts'" routerLink="./billing" fragment="discounts">Discounts</a>
        </div>
      </div>

      <article>
        <router-outlet/>
      </article>
    </div>
  </div>
</tp-page-scaffold>
